<template>
  <!-- v-clickoutside="isShow" @click="bol=true" -->
  <div id="seasonDrop" @mouseover="mouseover" @mouseout="mouseout">
    <slot name="title">{{title}}</slot>
    <!-- 下拉框 -->
    <transition name="dropNew">
      <!-- :style="{'margin-left': (- margin + 28) + '*$width'}" -->
<!--      <div ref="drop" class="drop" :class="{'minWidth': widthBol}"  v-show="true">-->
<!--        <div class="drop_header">-->
<!--          <div class="drop_header_item bold" v-for="item in list" :key="item[0]">-->
<!--            <i></i>-->
<!--            &lt;!&ndash; SKT集团旗下活动 &ndash;&gt;-->
<!--            <span>{{item[0]|sourceTitle}}</span>-->
<!--          </div>-->
<!--        </div>-->
<!--        &lt;!&ndash; 每一个大活动类型 &ndash;&gt;-->
<!--        <div class="drop_list">-->
<!--          <div class="drop_list_box" v-for="item in list" :key="item[0]">-->
<!--            <div v-for="arr in item[1]" :key="item[0] + arr[0]">-->
<!--              &lt;!&ndash; 活动的类型名称 &ndash;&gt;-->
<!--              <div class="drop_list_li_header" v-if="arr[0] != 'type_0'" @click="a(arr[1][0])">-->
<!--                <div class="drop_list_li_header_text">-->
<!--                  <span class="bold">· {{arr[0] | typeTitle}}</span>-->
<!--                  <span class="arrow blpc no_select" :class="{'arrow_close':!arr[1][0].bol}">&#xe6ca;</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              &lt;!&ndash; 每一个单独的活动 &ndash;&gt;-->
<!--              <div class="drop_list_li_box"-->
<!--              :style="{'max-height':arr[1][0].bol?(arr[1].length*44 + '*$width'):0}">-->
<!--                <div class="drop_list_li" v-for="li in arr[1]" :key="li.contestId">-->
<!--                  <div class="drop_list_li_text cursor"-->
<!--                  @click.stop="dropBtn(li)"-->
<!--                  :title="li.nameEn + ' ' + li.nameCn">-->
<!--                    <span class="drop_list_li_text_type no_select" v-if="li.enterStatus==2">报名中</span>-->
<!--                    <span>{{li.nameEn}} {{li.nameCn}}</span>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="dropNew" v-show="bol">
        <div class="dropItem" v-for="(item, index) in finalList" :key="index" v-show="item.length && item.length > 0">
          <div class="header">
            <div class="blueLine"></div>
            <div class="dropItemTitle" alt="">{{$t(`${typeList[index]}`)}}</div>
            <div class="wholeName">{{$t(`${typeList[index]}`)}}</div>
          </div>
          <div class="content" v-for="(ele, i) in item" :key="i+ 'w'">
            <div class="item" @click.stop="dropBtn(ele)">
              <div class="tag" v-if="ele.enterStatus==2">{{$t('flowHome13')}}</div>
              <div class="contentTxt ellipsis">{{ele.nameEn + '&nbsp;' + ele.nameCn}}</div>
              <div class="wholeName">{{ele.nameEn+ '&nbsp;' + ele.nameCn}}</div>
            </div>
          </div>
          <div v-for="(item, index2) in finalList" :key="index2 + 999" class="line" v-show="index!== 0"></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { gotoActivityHome } from '@/utils/activityHome'

export default {
  name: 'seasonDrop',
  props: {
    projectList: {
      type: Array,
      default: () => {
        return []
      }
    },
    title: {}
  },
  data () {
    return {
      typeList: ['flowHome7', 'flowHome8', 'flowHome9', 'flowHome10', 'flowHome11', 'flowHome12', 'flowHome114'],
      finalList: [], // 新的数据表
      widthBol: false,     // 浏览器宽度是否小于最大值 1550
      disabledBol: false,  // 是否可以下拉框展开了
      liBol: false,
      margin: 0,
      bol: false,          // 下拉框的显示
      list: new Map(),
      timer: null    // 定时器
    }
  },
  methods: {
    a (item) {
      item.bol = !item.bol
      this.$forceUpdate()
    },
    // 点击下拉列表：对齐 H5，依赖列表项 joinCount/joined，未知则进详情
    dropBtn (command) {
      this.toPage()
      this.$utils.CzcTrackEvent(this.$route.name, '活动下拉框', command.nameEn)
      gotoActivityHome(this, {
        nameEn: command.nameEn,
        contestId: command.contestId,
        seasonId: command.seasonId,
        joinCount: command.joinCount,
        joined: command.joined
      })
    },
    // 鼠标移进来了
    mouseover () {
      if (this.disabledBol) return
      this.bol = true
      this.$emit('bol', this.bol)
      clearTimeout(this.timer)
    },
    // 鼠标出来了
    mouseout () {
      this.timer = setTimeout(() => {
        this.bol = false
        this.$emit('bol', this.bol)
      }, 100)
    },
    toPage () {
      this.disabledBol = true
      this.bol = false
      this.$emit('bol', this.bol)
      // 兼容不重复拉取
      setTimeout(() => {
        this.disabledBol = false
      }, 200)
    },
    // 点击外面
    isShow () {
      this.bol = false
      this.$emit('bol', this.bol)
    },
    resizeFn () {
      // console.log(this.$utils.getWindowWidth(), 'this.$utils.getWindowWidth()')
      if (this.$utils.getWindowWidth() <= 1500) {
        this.widthBol = true
      } else {
        this.widthBol = false
      }
    },
    // 初始化
    init () {
      this.list.clear()
      // for (let i in this.projectList) {
      //   let obj = this.projectList[i]
      //   let sourceType = `sourceType_${obj.sourceType}`
      //   let sonMap = this.list.get(sourceType) || new Map()
      //   let type = obj.type ? `type_${obj.type}` : 'type_0'
      //   let arr = sonMap.get(type) || []
      //   obj.bol = true
      //   arr.push(obj)
      //   sonMap.set(type, arr)
      //   this.list.set(sourceType, sonMap)
      // }
      let list = [[], [], [], [], [], [], []] // SKT
      let list2 = [[], [], [], [], [], [], []] // 学生活动
      let list3 = [[], [], [], [], [], [], []]  // Bloom+
      console.log(this.projectList, 'projectList')
      for (let i in this.projectList) {
        let obj = this.projectList[i]
        console.log(obj, obj.sourceType, obj.type, 'obj')
        switch (+obj.sourceType) {
          case 1:
            if (obj.type) {
              obj.bol = true
              if (list[obj.type - 1] instanceof Array) {
                list[obj.type - 1].push(obj)
              } else {
                list[obj.type - 1] = []
                list[obj.type - 1].push(obj)
              }
            }
            break
          case 2:
            if (obj.type) {
              if (list2[obj.type - 1] instanceof Array) {
                list2[obj.type - 1].push(obj)
              } else {
                list2[obj.type - 1] = []
                list2[obj.type - 1].push(obj)
              }
            }
            break
          case 3:
            if (obj.type) {
              if (list3[obj.type - 1] instanceof Array) {
                list3[obj.type - 1].push(obj)
              } else {
                list3[obj.type - 1] = []
                list3[obj.type - 1].push(obj)
              }
            }
            break
        }
      }
      let finalList = []
      for (let i = 0; i < list.length; i++) {
        finalList[i] = [...list[i], ...list2[i], ...list3[i]] // 将所有类型拼接
      }
      // type 1 通识学术 2 财经商业 3 生命健康 4 科学工程 5 人文社科 6 智慧领导力 7 短期课程
      // 1 财经商业 2 生命健康 3 通识学术 4 人文社科 5 科学工程 6 智慧领导力 新的 7 短期课程
      let arr = [finalList[1], finalList[2], finalList[0], finalList[4], finalList[3], finalList[5], finalList[6]]
      // for (let i = 0; i < finalList.length; i++) {
      //   switch () {
      //
      //   }
      // }
      this.finalList = arr
      // for (let i in this.projectList) {
      //   let obj = this.projectList[i]
      //   console.log(obj, '7777')
      //   let sourceType = `sourceType_${obj.sourceType}`
      //   let sonMap = this.list.get(sourceType) || new Map()
      //   let type = obj.type ? `type_${obj.type}` : 'type_0'
      //   let arr = sonMap.get(type) || []
      //   obj.bol = true
      //   arr.push(obj)
      //   sonMap.set(type, arr)
      //   this.list.set(sourceType, sonMap)
      // }
      // this.margin = this.list.size * 284 / 2
      console.log(this.finalList, 'finalList')
    }
  },
  mounted () {
    this.resizeFn()
    window.addEventListener('resize', this.resizeFn, false)
  },
  created () {
    this.init()
  },
  destroyed () {
    clearTimeout(this.timer)
    window.removeEventListener('resize', this.resizeFn)
  },
  watch: {
    'projectList' () {
      this.init()
    }
  },
  filters: {
    typeTitle (val) {
      if (val === 'type_1') {
        return 'flowHome9'
      } else if (val === 'type_2') {
        return 'flowHome7'
      } else if (val === 'type_3') {
        return 'flowHome8'
      } else if (val === 'type_4') {
        return 'flowHome11'
      } else if (val === 'type_5') {
        return 'flowHome10'
      } else if (val === 'type_6') {
        return 'flowHome12'
      } else if (val === 'type_7') {
        return 'flowHome114'
      }
    },
    sourceTitle (val) {
      if (val === 'sourceType_1') {
        return 'flowHome14'
      } else if (val === 'sourceType_2') {
        return 'Bloom+'
      } else if (val === 'sourceType_3') {
        return 'flowHome15'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$width : 100vw/1920;
#seasonDrop{
  position: relative;
  //.drop{
  //  // border-top: 1*$width solid #F6F9FC;
  //  cursor: default;
  //  position: absolute;
  //  overflow: hidden;
  //  z-index: 9999;
  //  top: 60*$width;
  //  left: 28*$width;
  //  transform: translateX(-50%);
  //  background: #FFFFFF;
  //  box-shadow: 0 6*$width 12*$width 0 #F0F1F4;
  //  border-radius: 0 0 8*$width 8*$width;
  //  .drop_header{
  //    width: 100%;
  //    display: flex;
  //    padding: 14*$width 0;
  //    border-bottom: 1*$width solid #F6F9FC;
  //      .drop_header_item{
  //        width: 284*$width;
  //        box-sizing: border-box;
  //        padding-left: 24*$width;
  //        font-size: 16*$width;
  //        line-height: 21*$width;
  //        display: flex;
  //        i{
  //          display: block;
  //          background: #296BFF;
  //          width: 4*$width;
  //          height: 12*$width;
  //          border-radius: 2*$width;
  //          margin-top: 4.4*$width;
  //          margin-right: 8*$width;
  //        }
  //      }
  //  }
  //  .drop_list{
  //    display: flex;
  //    .drop_list_box::-webkit-scrollbar{
  //      display: block;
  //      width : 6*$width;  /*高宽分别对应横竖滚动条的尺寸*/
  //    }
  //    .drop_list_box::-webkit-scrollbar-thumb {
  //      /*滚动条里面小方块*/
  //      border-radius: 3*$width;
  //      background   : #D8D8D8;
  //    }
  //    .drop_list_box{
  //      width: 284*$width;
  //      box-sizing: border-box;
  //      border-right: 1*$width solid #F6F9FC;
  //      max-height: 480*$width;
  //      max-height: 70vh;
  //      overflow-x: scroll;
  //      .drop_list_li_header{
  //        padding: 4*$width 8*$width;
  //        font-size: 14*$width;
  //        line-height: 20*$width;
  //        .drop_list_li_header_text:hover{
  //          background: #F6F9FC;
  //        }
  //        .drop_list_li_header_text{
  //          padding: 8*$width 16*$width;
  //          border-radius: 2*$width;
  //          display: flex;
  //          justify-content: space-between;
  //          .arrow{
  //            font-size: 10*$width;
  //            line-height: 20*$width;
  //            color: #E8E9F1;
  //            transform: rotate(90deg);
  //            transition: all 0.3s;
  //          }
  //          .arrow_close{
  //            transform: rotate(0deg);
  //          }
  //        }
  //      }
  //      .drop_list_li_box{
  //        overflow: hidden;
  //        transition: all 0.3s;
  //      }
  //      .drop_list_li{
  //        padding: 4*$width 8*$width;
  //        font-size: 14*$width;
  //        line-height: 20*$width;
  //        .drop_list_li_text{
  //          padding: 8*$width 16*$width;
  //          border-radius: 2*$width;
  //          overflow: hidden;
  //          text-overflow:ellipsis;
  //          white-space: nowrap;
  //          .drop_list_li_text_type{
  //            display: inline-block;
  //            border: 1*$width solid #FF3049;
  //            border-radius: 2*$width;
  //            font-size: 10*$width;
  //            height: 12*$width;
  //            padding: 0 3*$width 1*$width;
  //            line-height: 14*$width;
  //            color: #FF3049;
  //            position: relative;
  //            top: -2*$width;
  //          }
  //        }
  //        .drop_list_li_text:hover{
  //          background: #F6F9FC;
  //          color: #296BFF;
  //        }
  //      }
  //    }
  //    .drop_list_box:nth-last-of-type(1) {
  //      border-right: 1*$width solid transparent;
  //    }
  //  }
  //}
  .dropNew {
    box-shadow: 0px 8px 16px 0px rgba(42,61,143,0.23);
    color: #1C1C1C;
    cursor: default;
    position: absolute;
    overflow: auto;
    z-index: 9999;
    top: 60*$width;
    left: 28*$width;
    transform: translateX(-30%);
    //background: #FFFFFF;
    background: rgba(255,255,255,0.97);
    //background: #FFFFFF;
    //opacity: 0.96;
    max-height: 520*$width;
    min-height: 350*$width;
    border-radius: 8*$width;
    display: flex;
    overscroll-behavior-y: contain;
    .dropItem{
      width: 240*$width;
      position: relative;
      min-height: 240*$width;
      .header{
        padding: 10*$width 24*$width;
        display: flex;
        align-items: center;
        background: #E2E9FD;
        position: sticky;
        .blueLine{
          width: 4*$width;
          height: 13*$width;
          background: #296BFF;
          border-radius: 2*$width;
          margin-right: 6*$width;
        }
        .wholeName{
          overflow: visible;
          display: none;
          position: absolute;
          bottom: -15*$width;
          left: 30*$width;
          height: 20*$width;
          line-height: 19*$width;
          background: #FFFFFF;
          box-shadow: 0*$width 1*$width 2*$width 0*$width #D8DCE6;
          border-radius: 2*$width;
          z-index: 10000;
          font-size: 11*$width;
          padding: 2*$width;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #5A5F6B;
          padding: 2*$width 5*$width;
          white-space: nowrap;
        }
        .dropItemTitle{
          flex: 1;
          height: 20*$width;
          line-height: 20*$width;
          font-size: 14*$width;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #030A17;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 14*$width
        }
      }
      .header:hover{
        .wholeName{
          display: inline-block;
        }
      }
      .content{
        padding: 10*$width 12*$width;
        //background: rgba(255,255,255,0.92);
        position: relative;
        overflow: visible;
        .item {
          display: flex;
          width: 216*$width;
          height: 30*$width;
          //background: #DBE6FF;
          border-radius: 4*$width;
          align-items: center;
          cursor: pointer;
          overflow: visible;
          .tag {
            justify-content: center;
            display: flex;
            align-items: center;
            min-width: 46*$width;
            min-height: 16*$width;
            width: fit-content;
            max-width: 76*$width;
            height: fit-content;
            max-height: 28*$width;
            background: #FFE4E2;
            border-radius: 4*$width;
            border: 1*$width solid #FF9791;
            margin-left: 6*$width;
            font-size: 12*$width;
            line-height: 10*$width;
            letter-spacing: .5*$width;
            white-space: pre-wrap;
            text-align: center;
            color: #F4170A;
            padding: 2*$width 0;
          }
          .contentTxt {
            margin-left: 6*$width;
            height: 20*$width;
            line-height: 20*$width;
            flex: 1;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 13*$width;
          }
          .wholeName{
            overflow: visible;
            display: none;
            position: absolute;
            bottom: -5*$width;
            left: 30*$width;
            height: 20*$width;
            line-height: 19*$width;
            background: #FFFFFF;
            box-shadow: 0*$width 1*$width 2*$width 0*$width #D8DCE6;
            border-radius: 2*$width;
            z-index: 10000;
            font-size: 11*$width;
            padding: 2*$width;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #5A5F6B;
            padding: 2*$width 5*$width;
            white-space: nowrap;
          }
        }
        .item:hover {
          background: #DBE6FF;
          .contentTxt{
            color: #296BFF;
            font-weight: 600;
          }
          .wholeName{
            display: inline-block;
          }
        }
      }
      .line{
        width: 1*$width;
        //height: 263*$width;
        height: 100%;
        background: #E3E8F3;
        position: absolute;
        z-index: 9999;
        top: 40*$width;
      }
    }
    .dropTtem::after{
      content: "▇";
      width: 1*$width;
      height: 263*$width;
      background: #E3E8F3;
    }
  }
  .dropNew::-webkit-scrollbar{
    display: block !important;
    width : 10*$width !important;  /*高宽分别对应横竖滚动条的尺寸*/
  }
  .dropNew::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    //border-radius: 3*$width;
    background   : #D8D8D8 !important;
    width: 15*$width !important;
    //background: #CAD0E3;
    border-radius: 5*$width !important;
  }
  .minWidth{
    position: fixed;
    top: 60*$width;
    left: 0;
    transform: translateX(0);
  }
  //.dropNew::after {
  //  content: "";
  //  background: #FFFFFF;
  //  opacity: 0.5;
  //  position: absolute;
  //  top: 0;
  //  left: 0;
  //  right: 0;
  //  bottom: 0;
  //  -webkit-filter: blur(5px);
  //  filter: blur(5px);
  //}
  @media (max-width: 1500*$width) {
    .dropNew {
      max-width: 1204*$width;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/season-drop.vue